import Icon from '../components/Icon.vue'

Icon.register({
  'star-and-crescent': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M340.5 466.4C339 466.4 333.6 466.8 331.3 466.8 215 466.8 120.5 372.3 120.5 256S215 45.2 331.3 45.2C333.6 45.2 339 45.6 340.5 45.6 347.6 45.6 353.8 40.6 355.2 33.6 356.7 26.3 352.7 19.1 345.8 16.5 316.6 5.5 286.4 0 256 0 114.8 0 0 114.8 0 256S114.8 512 256 512C286.2 512 316.3 506.5 345.3 495.7 351.3 493.7 355.6 488 355.6 481.4 355.6 473.3 349.2 466.4 340.5 466.4zM503.5 213.9L427.1 202.8 392.9 133.6C391.1 129.9 387.5 128 384 128S376.9 129.9 375.1 133.6L340.9 202.8 264.5 213.9C256.4 215 253.1 225.1 259 230.8L314.3 284.7 301.2 360.8C300.1 367.2 305.2 372.4 311 372.4 312.6 372.4 314.1 372.1 315.7 371.3L384 335.4 452.3 371.3C453.8 372.1 455.4 372.4 456.9 372.4 462.8 372.4 467.9 367.2 466.8 360.8L453.7 284.7 509 230.8C514.9 225.1 511.6 215 503.5 213.9z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/star-and-crescent.js
// module id = pekX
// module chunks = 144